import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { tasksQueriesKeys } from './constants.js'

/**
 * Fetches media parent data (post or task comment).
 * @param {string} projectId - ID of the project.
 * @param {string} search - Search param to use to search members.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - The query object with parent media data. The response includes a header 'dt-type'
 * that indicates whether the returned item is a media post or a media task comment, depending on where
 * the media is located.
 */

export const useGetProjectTeamsQuery = (projectId, search = '', options) => {
  const fetchProjectTeams = async () => {
    const config = {
      method: 'GET',
      params: {
        size: 100,
        page: 0,
        sortBy: 'Name',
        sortDirection: 'ASC',
        teamGroupStateFilter: 'All',
        search
      }
    }

    const { data } = await api(
      `/api/team-groups-api/projects/${projectId}`,
      config
    )

    return data.content.filter((team) => team.active)
  }

  return useQuery({
    queryKey: [tasksQueriesKeys.GET_PROJECT_TEAMS, projectId, search],
    queryFn: fetchProjectTeams,
    enabled: !!projectId,
    ...options
  })
}
